export default function addOpacityToRGB(rgb: string, opacity: number) {
	const rgbRegex = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/;
	const match = rgb.match(rgbRegex);

	if (!match) {
		return null;
	}

	const red = parseInt(match[1], 10);
	const green = parseInt(match[2], 10);
	const blue = parseInt(match[3], 10);

	if (opacity < 0 || opacity > 1) {
		return null;
	}

	return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
